import { prefix } from '@/configs/testAutomation';

const constructedIds = {
  cancelRequestBtn: '',
  retreatBtn: '',
  rejectRequestBtn: '',
  toaster: {
    error: '',
  },
};

function generateIds(obj: any, parentNodes: string[] = []) {
  const mutatedIds: any = {};

  Object.keys(obj).forEach((key) => {
    if (typeof obj[key] === 'object') {
      const nodes = [...parentNodes, key];
      mutatedIds[key] = { ...generateIds(obj[key], nodes) };
    } else {
      mutatedIds[key] = !parentNodes.length ? `${prefix}_${key}` : `${prefix}_${parentNodes.join('_')}_${key}`;
    }
  });

  return mutatedIds;
}

export const testIds = generateIds(constructedIds);
